import React, { ReactNode } from 'react';
import classnames from 'classnames';

import './TableBlock.css';
import GlobalProps from '../globalProps';

interface Props extends GlobalProps {
  header?: ReactNode;
  footer?: ReactNode;
  icon?: ReactNode;
  maxWidth?: string;
  wordBreak?: 'normal' | 'break-all' | 'keep-all' | 'break-word' | 'initial' | 'inherit';
}

export function TableBlock({ header, footer, icon, maxWidth, wordBreak, className, style }: Props): JSX.Element {
  return (
    <div style={{ maxWidth, wordBreak, ...style }} className={classnames('tableblock', className)}>
      <div className="tableblock__text-wrapper">
        {header && <div className="tableblock__header">{header || ''}</div>}
        {footer && <div className="tableblock__footer">{footer || ''}</div>}
      </div>
      {icon && <span className="tableblock__icon">{icon}</span>}
    </div>
  );
}
